/**
 * SkipLink — keyboard-only "skip to main content" link.
 *
 * WCAG 2.4.1 Bypass Blocks: keyboard users can tab past the navigation
 * and jump straight to the main content. Without this, a screen reader
 * user has to traverse 6-8 nav links on every page.
 *
 * Visually hidden until focused, then becomes a visible button at the
 * top-left of the viewport. The link targets `#main` — every page
 * should have a `<main id="main">` element.
 */
export default function SkipLink() {
  return (
    <a
      href="#main"
      className="
        sr-only focus:not-sr-only
        focus:absolute focus:top-2 focus:start-2 focus:z-50
        focus:px-4 focus:py-2 focus:rounded
        focus:bg-brass-500 focus:text-walnut-950
        focus:font-caps focus:text-[11px] focus:tracking-[0.2em] focus:uppercase
        focus:shadow-lg focus:outline-none
      "
    >
      Skip to main content
    </a>
  );
}
